(() => {
  const VERSION = '2026-09-30.1';
  if (window.AvonticRhinoPerfection?.version === VERSION) return;
  const ROOT = '#avontic-primary-product';
  const $ = (root, selector) => root?.querySelector(selector);
  const all = (root, selector) => Array.from(root?.querySelectorAll(selector) || []);
  const put = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  let stickyFrame = 0;

  const moveModelFirst = (root) => {
    const picker = $(root, 'variant-picker');
    if (!picker) return;
    const groups = all(picker, ':scope > fieldset.variant-picker__option, :scope > .variant-picker__option');
    const model = groups.find((group) => group.dataset.avExplicitSelectionOption === 'true' || /size|model|device|generation|series/i.test(group.querySelector('legend')?.textContent || ''));
    const color = groups.find((group) => /color|colour|finish/i.test(group.querySelector('legend')?.textContent || ''));
    if (model && color && color.previousElementSibling !== model) color.before(model);
  };

  const enforcePurchaseOrder = (root) => {
    const list = $(root, '.product-info__block-list');
    if (!list) return;
    const price = $(list, '[data-block-id="price"]');
    const finder = $(list, '[data-block-id="atlas_model_finder"]');
    const chip = $(list, '[data-block-id="rg_system_chip"]');
    const picker = $(list, '[data-block-id="variant_picker"]');
    const quantity = $(list, '[data-block-id="quantity_selector"]');
    const buy = $(list, '[data-block-id="buy_buttons"]');
    const story = $(list, '[data-block-id="rhinoguard_buybox_story"]');
    let cursor = price;
    [finder, picker, chip, buy, story].filter(Boolean).forEach((node) => {
      if (cursor && cursor.nextElementSibling !== node) cursor.after(node);
      cursor = node;
    });

    const summaryBlock = $(list, '[data-block-id="atlas_selection_summary"]');
    const summary = summaryBlock?.querySelector('avontic-pdp-selection-summary') || $(list, 'avontic-pdp-selection-summary');
    const buyElement = buy?.querySelector('buy-buttons');
    if (summary && buyElement) {
      let host = buy.querySelector(':scope > .av-rg-purchase-selection, :scope > .av-rg-post-atc-selection');
      if (!host) {
        host = document.createElement('div');
        buy.prepend(host);
      }
      host.className = 'av-rg-purchase-selection';
      if (host.parentElement !== buy || buy.firstElementChild !== host) buy.prepend(host);
      if (summary.parentElement !== host) host.append(summary);
      if (summaryBlock && !summaryBlock.textContent.trim()) summaryBlock.hidden = true;
    }

    const atc = buyElement?.querySelector('[data-av-atc-control]');
    if (buyElement && atc) {
      let actionRow = buyElement.querySelector('.av-rg-primary-action-row');
      if (!actionRow) {
        actionRow = document.createElement('div');
        actionRow.className = 'av-rg-primary-action-row';
        buyElement.prepend(actionRow);
      }
      if (atc.parentElement !== actionRow) actionRow.append(atc);
    }

    // Keep the quantity selector inside its own theme block and place that whole block
    // directly above the product form. Prestige's partial re-render only refreshes a
    // quantity block that still contains its <quantity-selector>, so moving the selector
    // out of the block made it disappear after the first variant change.
    const productForm = buyElement?.closest('product-form');
    if (quantity && buy && productForm && productForm.parentElement && buy.contains(productForm)) {
      const strayQuantity = buyElement.querySelector('.av-rg-primary-action-row > .v-stack');
      if (strayQuantity && !quantity.querySelector('quantity-selector')) quantity.append(strayQuantity);
      if (productForm.previousElementSibling !== quantity) productForm.before(quantity);
      const quantityContent = quantity.firstElementChild;
      if (quantityContent && !quantityContent.querySelector('.av-rg-quantity-label')) {
        const quantityLabel = document.createElement('span');
        quantityLabel.className = 'av-rg-quantity-label';
        quantityLabel.textContent = 'Quantity';
        quantityContent.prepend(quantityLabel);
      }
      quantity.hidden = !quantity.querySelector('quantity-selector');
    }
  };

  const buildFallbackFinder = (root) => {
    const host = $(root, '[data-block-id="atlas_model_finder"]');
    if (!host || $(host, 'avontic-pdp-model-finder, .av-rg-fit-fallback')) return;
    const picker = $(root, 'variant-picker');
    const groups = all(picker, ':scope > fieldset.variant-picker__option, :scope > .variant-picker__option');
    const modelGroup = groups.find((group) => group.dataset.avExplicitSelectionOption === 'true' || /size|model|device|generation|series/i.test(group.querySelector('legend')?.textContent || ''));
    const labels = all(modelGroup, 'label[for]').filter((label) => /\bA\d{4}\b/i.test(label.textContent || ''));
    if (!modelGroup || !labels.length) return;

    const details = document.createElement('details');
    details.className = 'av-rg-fit-fallback';
    details.innerHTML = '<summary><span><small>Exact-fit A-number check</small><strong>Match your iPad before you order</strong></span><span aria-hidden="true">+</span></summary><div class="av-rg-fit-fallback__body"><p>Find the A-number on the back of your iPad, then match it to the exact case size.</p><div class="av-rg-fit-fallback__controls"><label><span>iPad model number</span><input type="text" inputmode="text" autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="5" placeholder="A####" aria-label="iPad model number"></label><button type="button">Find my exact fit</button></div><p class="av-rg-fit-fallback__result" aria-live="polite"></p><a href="sms:+19733700215">Not sure? Text the Fit Concierge</a></div>';
    host.append(details);

    const input = $(details, 'input');
    const button = $(details, 'button');
    const result = $(details, '.av-rg-fit-fallback__result');
    const persisted = window.__avonticRhinoFitMatch;
    const selectedControl = $(modelGroup, 'input:checked');
    const selectedLabel = selectedControl ? labels.find((label) => label.htmlFor === selectedControl.id) : null;
    if (persisted && selectedLabel && (selectedLabel.textContent || '').toUpperCase().match(/A\d{4}/g)?.includes(persisted.model)) {
      input.value = persisted.model;
      result.textContent = 'Exact match: ' + (selectedLabel.querySelector('span')?.textContent || selectedLabel.textContent || '').trim();
      result.classList.add('is-success');
      details.open = true;
    } else if (persisted) {
      window.__avonticRhinoFitMatch = null;
    }
    const matchModel = () => {
      let model = (input.value || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (/^\d{4}$/.test(model)) model = 'A' + model;
      input.value = model;
      result.classList.remove('is-success', 'is-error');
      if (!/^A\d{4}$/.test(model)) {
        result.textContent = 'Enter one A followed by four digits, such as A2757.';
        result.classList.add('is-error');
        return;
      }
      const matches = labels.filter((label) => (label.textContent || '').toUpperCase().match(/A\d{4}/g)?.includes(model));
      if (matches.length !== 1) {
        result.textContent = matches.length ? 'More than one configuration matches. Use the Fit Concierge to confirm.' : 'That A-number is not listed for this product. Use the Fit Concierge before ordering.';
        result.classList.add('is-error');
        return;
      }
      const control = document.getElementById(matches[0].htmlFor);
      const optionText = (matches[0].querySelector('span')?.textContent || matches[0].textContent || '').trim();
      window.__avonticRhinoFitMatch = { model, optionText };
      if (control && !control.checked) control.click();
      result.textContent = 'Exact match: ' + optionText;
      result.classList.add('is-success');
    };
    button.addEventListener('click', matchModel);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        matchModel();
      }
    });
  };

  const refineSelectionCopy = (root) => {
    const summary = $(root, 'avontic-pdp-selection-summary');
    if (!summary) return;

    const essential = $(summary, '[data-av-pdp-essential]');
    if (essential) {
      const shortModel = String(essential.textContent || '').split('|')[0].trim();
      if (shortModel) put(essential, shortModel);
    }

    const finish = $(summary, '[data-av-pdp-finish]');
    if (finish) {
      const words = String(finish.textContent || '').trim().split(/\s+/).filter(Boolean);
      const half = words.length / 2;
      const deduped = Number.isInteger(half) && half > 0 && words.slice(0, half).join(' ').toLowerCase() === words.slice(half).join(' ').toLowerCase()
        ? words.slice(0, half).join(' ')
        : words.join(' ');
      if (deduped) put(finish, deduped);
    }

    const state = summary.dataset.state || '';
    if (state === 'review-required' || state === 'confirmation-required') {
      put($(summary, '[data-av-pdp-state]'), 'Confirm your iPad model');
      put($(summary, '[data-av-confirm-selection-label]'), 'Confirm this iPad model');
    }
  };

  const refinePrimaryAction = (root) => {
    const button = $(root, '[data-block-id="buy_buttons"] [data-av-atc-control]');
    const priceText = ($(root, '[data-block-id="price"] sale-price')?.textContent || '').replace(/\s+/g, ' ').trim();
    const priceMatch = priceText.match(/[$£€]\s*\d[\d,]*(?:\.\d{2})?/) || priceText.match(/\d[\d,]*(?:\.\d{2})?\s*(?:USD|CAD|AUD|NZD|GBP|EUR)/i);
    const price = priceMatch ? priceMatch[0].replace(/\s+(?=\d)/g, '') : '';
    if (!button || !price || button.disabled || !/^add to cart/i.test(button.textContent || '')) return;
    const baseLabel = String(button.dataset.avRgBaseLabel || button.textContent || 'Add to cart').split(/[·•]/)[0].replace(/\s+price\s*$/i, '').trim() || 'Add to cart';
    button.dataset.avRgBaseLabel = baseLabel;
    // Keep the purchase action stable; the shared buy box displays the item subtotal.
    put(button, baseLabel);
  };

  const refineAssurance = (root) => {
    const assurance = $(root, '.av-purchase-assurance');
    if (!assurance || assurance.dataset.avPerfected === 'true') return;
    assurance.dataset.avPerfected = 'true';
  };

  const getDescriptionStory = (description) => {
    if (!description) return null;
    return $(description, ':scope > article') || all(description, ':scope > *').find((child) => !child.matches('style, script, nav'));
  };

  const buildProofNav = (root) => {
    if (root?.dataset.avRgEditorial === 'true') return; // The editorial has stable, native anchors.
    const description = $(root, '.product-content-below-gallery__description');
    if (!description) return;
    const existing = $(description, '.av-rg-proof-nav');
    if (existing) {
      if (existing.parentElement !== description) description.prepend(existing);
      return;
    }
    const headings = all(description, 'h2, h3');
    const specs = [
      ['Performance', /functions|protection|control|workstation|system/i],
      ['Exact fit', /exact.?fit|match the|compatib/i],
      ['In the box', /in the box|what ships|included/i],
      ['FAQs', /questions|before you buy|faq/i]
    ];
    const links = [];
    specs.forEach(([label, pattern], index) => {
      const heading = headings.find((candidate) => pattern.test(candidate.textContent || '') && !candidate.dataset.avProofClaimed);
      if (!heading) return;
      heading.dataset.avProofClaimed = 'true';
      if (!heading.id) heading.id = 'av-rg-proof-' + index + '-' + Math.random().toString(36).slice(2, 7);
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = label;
      links.push(link);
    });
    if (links.length < 2) return;
    const nav = document.createElement('nav');
    nav.className = 'av-rg-proof-nav';
    nav.setAttribute('aria-label', 'Product guide');
    const title = document.createElement('strong');
    title.textContent = 'Explore the system';
    const rail = document.createElement('div');
    rail.className = 'av-rg-proof-nav__links';
    links.forEach((link) => rail.append(link));
    nav.append(title, rail);
    description.prepend(nav);
    all(description, 'section, [role="region"]').slice(2).forEach((section) => section.classList.add('av-rg-deferred-proof'));
  };

  const syncStickyState = () => {
    const root = document.querySelector(ROOT);
    const primary = $(root, '[data-block-id="buy_buttons"] [data-av-atc-control]');
    if (!root || !primary) return;
    const header = document.querySelector('.shopify-section--header, header');
    const footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('body > footer');
    const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
    const passed = primary.getBoundingClientRect().bottom <= headerBottom;
    const nearFooter = Boolean(footer && footer.getBoundingClientRect().top <= window.innerHeight);
    all(document, '.av-pdp-sticky-cockpit').forEach((sticky) => {
      sticky.dataset.avRgPassed = passed ? 'true' : 'false';
      sticky.dataset.avRgNearFooter = nearFooter ? 'true' : 'false';
    });
  };

  const scheduleStickyState = () => {
    window.cancelAnimationFrame(stickyFrame);
    stickyFrame = window.requestAnimationFrame(syncStickyState);
  };

  const dedupeKnownIds = () => {
    ['smart-menu', 'installments-modal'].forEach((id) => {
      all(document, `[id="${id}"]`).slice(1).forEach((node, index) => {
        node.id = `${id}-${index + 2}`;
      });
    });
  };

  const hydrate = () => {
    const root = document.querySelector(ROOT);
    if (!root || !$(root, '[data-av-rg-cro-config]')) return;
    moveModelFirst(root);
    buildFallbackFinder(root);
    enforcePurchaseOrder(root);
    refineSelectionCopy(root);
    refineAssurance(root);
    refinePrimaryAction(root);
    buildProofNav(root);
    dedupeKnownIds();
    scheduleStickyState();
  };

  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = 0; hydrate(); });
  };
  const start = () => {
    hydrate();
    const root = document.querySelector(ROOT);
    if (root) new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    const duplicateSelector = '[id="smart-menu"], [id="installments-modal"]';
    new MutationObserver((records) => {
      if (records.some((record) => Array.from(record.addedNodes || []).some((node) => node instanceof Element && (node.matches(duplicateSelector) || node.querySelector(duplicateSelector))))) dedupeKnownIds();
    }).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', schedule, { once: true });
    window.addEventListener('load', scheduleStickyState, { once: true });
    window.addEventListener('scroll', scheduleStickyState, { passive: true });
    window.addEventListener('resize', scheduleStickyState, { passive: true });
    window.addEventListener('pageshow', () => {
      scheduleStickyState();
      window.setTimeout(scheduleStickyState, 250);
    });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) scheduleStickyState();
    });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:load', scheduleStickyState);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
  window.AvonticRhinoPerfection = Object.freeze({ version: VERSION, hydrate: schedule });
})();


